export default {
  // publishToPlatforms
  START_PUBLISH_TO_PLATFORMS: "START_PUBLISH_TO_PLATFORMS",
  PUBLISH_TO_PLATFORMS_SUCCESS: "PUBLISH_TO_PLATFORMS_SUCCESS",
  PUBLISH_TO_PLATFORMS_FAILED: "PUBLISH_TO_PLATFORMS_FAILED",
  // getApplicationReleasePlatforms
  START_GET_APPLICATION_RELEASE_PLATFORMS: "START_GET_APPLICATION_RELEASE_PLATFORMS",
  GET_APPLICATION_RELEASE_PLATFORMS_SUCCESS: "GET_APPLICATION_RELEASE_PLATFORMS_SUCCESS",
  GET_APPLICATION_RELEASE_PLATFORMS_FAILED: "GET_APPLICATION_RELEASE_PLATFORMS_FAILED",
  // getPlatformSettings
  START_GET_PLATFORM_SETTINGS: "START_GET_PLATFORM_SETTINGS",
  GET_PLATFORM_SETTINGS_SUCCESS: "GET_PLATFORM_SETTINGS_SUCCESS",
  GET_PLATFORM_SETTINGS_FAILED: "GET_PLATFORM_SETTINGS_FAILED",
  // addOrUpdatePlatformSettings
  START_ADD_OR_UPDATE_PLATFORM_SETTINGS: "START_ADD_OR_UPDATE_PLATFORM_SETTINGS",
  ADD_OR_UPDATE_PLATFORM_SETTINGS_SUCCESS: "ADD_OR_UPDATE_PLATFORM_SETTINGS_SUCCESS",
  ADD_OR_UPDATE_PLATFORM_SETTINGS_FAILED: "ADD_OR_UPDATE_PLATFORM_SETTINGS_FAILED"
}